// THE NULL HERALD (owner 2026-11-03: 'after 30 minutes there needs to be something that literally threatens my life'):
// a late-game hunter. Pure data + helpers; the behaviour lives in Sim (updateHerald / heraldDirector). Deterministic.

/** first herald this many scheduled seconds after the final boss time, then one every HERALD_GAP */
export const HERALD_FIRST = 60, HERALD_GAP = 180, HERALD_MAX_ALIVE = 2;
/** spawn distance from the hero (m) */
export const HERALD_SPAWN_R = 26;
/** each spawn index n (0 = the first): damage +10%/n capped at x2.0, speed +3%/n capped at x1.25 */
export const heraldDmgK = (n: number): number => Math.min(2, 1 + 0.1 * n);
export const heraldSpdK = (n: number): number => Math.min(1.25, 1 + 0.03 * n);
/** touch: 35% of the hero's max HP, once per HERALD_TOUCH_CD. Slam: 60% of max HP. No single hit exceeds HERALD_HIT_CAP. */
export const HERALD_TOUCH = 0.35, HERALD_TOUCH_CD = 1.0, HERALD_SLAM = 0.6, HERALD_HIT_CAP = 0.6;
/** slam: starts within HERALD_SLAM_RANGE, every HERALD_SLAM_CD, HERALD_SLAM_TELL s of warning, radius HERALD_SLAM_R */
export const HERALD_SLAM_RANGE = 9, HERALD_SLAM_CD = 4.5, HERALD_SLAM_TELL = 1.0, HERALD_SLAM_R = 4.5;
/** Relaxed run modifier scales the herald's damage */
export const HERALD_RELAXED = 0.7;
/** adaptive health: hp = max(base x hpMul x HERALD_BASE_K, recent dps x HERALD_DPS_SECONDS); dps averaged over HERALD_WINDOW s */
export const HERALD_BASE_K = 40, HERALD_DPS_SECONDS = 75, HERALD_WINDOW = 60;
/** reward on death */
export const HERALD_SHARDS = 250;
export const HERALD_SCALE = 2.2;
